import React from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from "./components/Header";
import Navbar from './components/Navbar';
import Footer from "./components/Footer";
import Home from './components/Home';
import Solutions from './components/Solutions';
import Specialties from './components/Specialties';
import Platform from './components/Platform';
import Pricing from './components/Pricing';
import Resources from './components/Resources';
import SolutionDetail from './components/SolutionDetail';
import SpecialtyDetail from './components/SpecialtyDetail';
import ScheduleDemo from "./components/ScheduleDemo";
import PatientPortal from "./components/PatientPortal";
import PatientLogin from "./components/PatientLogin";
import ProtectedRoute from "./components/ProtectedRoute";
import Contact from './components/Contact';
import About from './components/About';
import PracticeManagement from './components/solutions/PracticeManagement';
import PatientEngagement from './components/solutions/PatientEngagement';
import ClinicalTools from './components/solutions/ClinicalTools';
import AIXrayAnalysisCTA from './components/AIXrayAnalysisCTA';
import SmartScheduling from './components/SmartScheduling';
import AIVirtualFrontDesk from './components/AIVirtualFrontDesk';
import AIChatbot from './components/AIChatbot';
import AIClinicalAssistant from './components/AIClinicalAssistant';
import DentistPortal from './components/DentistPortal';
import PediatricDentistry from './components/PediatricDentistry';
import Analytics from './components/Analytics';
import PatientCommunication from './components/PatientCommunication';
import PatientPortalFeatures from './components/PatientPortalFeatures';
import SmartReminders from './components/SmartReminders';
import PatientEducation from './components/PatientEducation';

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen bg-gray-100">
        <Header />
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/solutions/practice-management" element={<PracticeManagement />} />
            <Route path="/solutions/patient-engagement" element={<PatientEngagement />} />
            <Route path="/solutions/clinical-tools" element={<ClinicalTools />} />
            <Route path="/solutions/:id" element={<SolutionDetail />} />
            <Route path="/specialties" element={<Specialties />} />
            <Route path="/specialties/:id" element={<SpecialtyDetail />} />
            <Route path="/platform" element={<Platform />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/smart-scheduling" element={<SmartScheduling />} />
            <Route path="/patient-login" element={<PatientLogin />} />
            <Route path="/schedule-demo" element={<ScheduleDemo />} />
            <Route 
              path="/patient-portal" 
              element={
                <ProtectedRoute>
                  <PatientPortal />
                </ProtectedRoute>
              } 
            />
            <Route path="/dentist-portal" element={<DentistPortal />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/about" element={<About />} />
            <Route path="/ai-virtual-front-desk" element={<AIVirtualFrontDesk />} />
            <Route path="/ai-chatbot" element={<AIChatbot />} />
            <Route path="/ai-clinical-assistant" element={<AIClinicalAssistant />} />
            <Route path="/pediatric-dentistry" element={<PediatricDentistry />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/patient-communication" element={<PatientCommunication />} />
            <Route path="/patient-portal-features" element={<PatientPortalFeatures />} />
            <Route path="/smart-reminders" element={<SmartReminders />} />
            <Route path="/patient-education" element={<PatientEducation />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;



// import React from "react";
// import Header from "./components/Header";
// import HeroSection from "./components/HeroSection";
// import ScheduleDemo from "./components/ScheduleDemo";  // Add this
// import Features from "./components/Features";
// import Services from "./components/Services";

// function App() {
//   return (
//     <>
//       <Header />
//       <HeroSection />
//       <ScheduleDemo />
//       <Features />
//       <Services />
//     </>
//   );
// }

// export default App;
